export default __webpack_public_path__ + "assets/front/scss/error.73ee13677a6dbb61d94e9b6975d22f89.css";